import jsonp from 'jsonp';

export default function Jsonp(url, params, props) {
  const config = {
    // param: props.jsonpName,
    // name: props.jsonpCallback,
    timeout: 5000,
  }
  const reqUrl = url;
  return new Promise((resolve, reject) => {
    const cancel = jsonp(reqUrl, config, (err, data) => {
      if(err) {
        reject(err);
        return;
      }
      resolve(data)
    })
  })
}